import { Component, inject, OnInit } from "@angular/core";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { faCircleUser } from "@fortawesome/free-solid-svg-icons";
import { AuthService } from "@app/core/services/auth.service";
import { StorageService } from "@app/core/services/storage.service";
import { TranslateService } from "@ngx-translate/core";
import { AppService } from "@app/core/services/app.service";

@Component({
  selector: "user-navbar",
  standalone: true,
  imports: [FontAwesomeModule],
  templateUrl: "./user-navbar.component.html",
  styleUrl: "./user-navbar.component.scss",
})
export class UserNavbarComponent implements OnInit {

  protected readonly faCircleUser = faCircleUser;
  private readonly translate = inject(TranslateService);
  protected userName: string;

  public isLoggedIn = false;
  public selectedLanguage = localStorage.getItem("currentLang");

  constructor(
    private appService: AppService,
    private authService: AuthService,
    private storageService: StorageService,
  ) {}

  ngOnInit(): void {
    this.checkLogin();
  }

  checkLogin() {
    this.storageService.isAuthentication.subscribe({
      next: (value) => {
        if (value) {
          this.isLoggedIn = true;
        }
      },
    });

    this.appService.appInfo$.subscribe({
      next: (appInfo) => {
        this.selectedLanguage = appInfo["user.lang"];
        this.userName = appInfo["user.name"];
      }
    });
  }

  logout() {
    this.authService.onLogout();
  }
}
